/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create and rename a condition. Its tree is written through the tree endpoint.
 * @export
 * @interface ConditionWrite
 */
export interface ConditionWrite {
    /**
     * 
     * @type {string}
     * @memberof ConditionWrite
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof ConditionWrite
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ConditionWrite
     */
    workflow: string;
}

/**
 * Check if a given object implements the ConditionWrite interface.
 */
export function instanceOfConditionWrite(value: object): value is ConditionWrite {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('workflow' in value) || value['workflow'] === undefined) return false;
    return true;
}

export function ConditionWriteFromJSON(json: any): ConditionWrite {
    return ConditionWriteFromJSONTyped(json, false);
}

export function ConditionWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionWrite {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'workflow': json['workflow'],
    };
}

export function ConditionWriteToJSON(json: any): ConditionWrite {
    return ConditionWriteToJSONTyped(json, false);
}

export function ConditionWriteToJSONTyped(value?: Omit<ConditionWrite, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'workflow': value['workflow'],
    };
}

